import React from 'react';
import {
    WppSegmentedControl,
    WppSegmentedControlItem,
    WppTooltip,
    WppIconInfo,
} from '@wppopen/components-library-react';
import { Main } from './SegmentControlStyles';
import { normalizeString, wppSize } from 'utils';

type DataProps = {
    label: string;
    value: string;
};

type DefaulTooltipTextProps = {
    [key: string]: string;
};

interface ISegementControl {
    value: string;
    handleChange: any;
    cases?: DataProps[];
    propertyKey: string;
    dataTestId: string;
    withTootip?: boolean;
    wppSize?: wppSize;
}

const defaultSelectionData = [
    { label: 'Cumulative', value: 'Cumulative' },
    { label: 'Per year', value: 'Per annum' },
];

const defaulTooltipText: DefaulTooltipTextProps = {
    ['Cumulative']: 'Cumulative: Total accumulation over time. Per Year: Amount per year.',
    ['Per annum']: 'Cumulative: Total accumulation over time. Per Year: Amount per year.',
};

export const SegmentControl = ({
    value,
    handleChange,
    cases = defaultSelectionData,
    propertyKey,
    dataTestId,
    wppSize = 's',
}: ISegementControl) => {
    return (
        <Main>
            <WppSegmentedControl
                value={value}
                onWppChange={(e) => handleChange(propertyKey, e.detail.value)}
                size={wppSize}
                data-testid={`${dataTestId}`}
            >
                {cases?.map((el: any) => (
                    <WppSegmentedControlItem
                        key={el.label}
                        itemID={el.value}
                        value={el.value}
                        data-testid={`${dataTestId}.${normalizeString(el.label)}`}
                    >
                        {el.label}
                    </WppSegmentedControlItem>
                ))}
            </WppSegmentedControl>
            <WppTooltip
                text={defaulTooltipText[value]}
                config={{
                    maxWidth: '300px',
                }}
            >
                <WppIconInfo />
            </WppTooltip>
        </Main>
    );
};
